/*
Componente para dar un rango de valores numericos [desde, hasta]
*/

import React, { useState } from 'react'
import PropTypes from 'prop-types'

// #region CSS
import { withStyles, makeStyles } from '@material-ui/core/styles'
import Slider from '@material-ui/core/Slider'
// import Typography from "@material-ui/core/Typography";
const useStyles = makeStyles(theme => ({
  root: {},
  margin: {
    height: theme.spacing(3)
  }
}))
const IluSlider = withStyles({
  root: {
    color: '#52af00',
    height: 8,
    marginTop: '20px'
  },
  thumb: {
    height: 24,
    width: 24,
    backgroundColor: '#fff',
    border: '2px solid currentColor',
    marginTop: -8,
    marginLeft: -12,
    '&:focus,&:hover,&$active': {
      boxShadow: 'inherit'
    }
  },
  active: {},
  valueLabel: {
    left: 'calc(-50% + 4px)',
    display: 'none'
  },
  track: {
    height: 8,
    borderRadius: 4
  },
  rail: {
    height: 8,
    borderRadius: 4
  }
})(Slider)
// #endregion

export default function RangeSlider({ onChange, initialState }) {
  const classes = useStyles()

  // #region Values
  const [max, setMax] = useState(initialState[1] + 500)
  // #endregion

  // #region HandleChange
  const handleChange = (event, value) => {
    if (value[1] >= 90000) {
      setMax(100000)
    } else {
      setMax(value[1] + 10000)
    }
    onChange(value)
  }

  const handleChangeCommitted = (event, value) => {
    onChange(value)
  }
  // #endregion

  return (
    <div className={classes.root}>
      {/* <Typography gutterBottom>Puntos</Typography> */}
      <IluSlider
        valueLabelDisplay='auto'
        value={initialState}
        min={0}
        max={max}
        step={100}
        onChange={handleChange}
        onChangeCommitted={handleChangeCommitted}
      />
    </div>
  )
}

RangeSlider.propTypes = {
  onChange: PropTypes.func.isRequired,
  initialState: PropTypes.array.isRequired
}
